export const fridayAbbreviatedLowercase = "jvr8Ub";
export default {fridayAbbreviatedLowercase};